// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/conditions-outline.svg';

export const ConditionsOutline = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
